let itemList = [{
    id: "1001",
    itemName: "华晟医学签约入驻南京生命科技小镇生物产业加速带园区。",
    itemTime: "2017-12-28",
    itemImage: "../../../../../static/image/dsj/dsjimage1001.jpg",
    remarK: '',
    itemYear: "2017"
  },
  {
    id: "1002",
    itemName: "华晟医学取得《医疗机构执业许可证》，销售运营管理团队就位。",
    itemTime: "2018-04-12",
    itemImage: "",
    remarK: '',
    itemYear: "2018"
  },
  {
    id: "1003",
    itemName: "确定战略方向，聚焦基层医疗，矢志打造“互联网+检验”科技型创新企业。",
    itemTime: "2018-10-08",
    itemImage: "",
    remarK: '',
    itemYear: "2018"
  },
  {
    id: "1004",
    itemName: "微E检1.0系统上线，苹果APP、安卓APP、微信公众号同步发布。",
    itemTime: "2018-11-10",
    itemImage: "",
    remarK: '',
    itemYear: "2018"
  },
  {
    id: "1005",
    itemName: "引入江河集团战略投资，全面实施实验室检测能力、市场服务能力提升计划。",
    itemTime: "2018-11-23",
    itemImage: "../../../../../static/image/dsj/dsjimage1005.jpg",
    remarK: '',
    itemYear: "2018"
  },
  {
    id: "1006",
    itemName: "南京市HIV筛查实验室验收合格，江苏省PCR技术验收合格，取得二类、三类医疗器械经营许可证，取得医疗机构医保资质。",
    itemTime: "2019-06-08",
    itemImage: "../../../../../static/image/dsj/dsjimage1006.jpg",
    remarK: '',
    itemYear: "2019"
  },

  {
    id: "1007",
    itemName: "华晟医学检验实验室的生物安全防护级别升级到BSL-2加强级别，临床基因扩增检验实验室通过专家组验收，医学生物安全二级实验室通过南京市卫健委备案审核。",
    itemTime: "2020-02",
    itemImage: "../../../../../static/image/dsj/dsjimage1007.jpg",
    remarK: '',
    itemYear: "2020"
  },


  {
    id: "1008",
    itemName: "成为南京市首批新型冠状病毒核酸定点检测机构",
    itemTime: "2020-02-22",
    itemImage: "../../../../../static/image/dsj/dsjimage0222.jpg",
    remarK: '',
    itemYear: "2020"
  },
  {
    id: "1009",
    itemName: "和南京江北新区生物医药谷签订投资协议，启动建设南京市第二家现代化全科医学检验实验室。",
    itemTime: "2020-02-28",
    itemImage: "../../../../../static/image/dsj/dsjimage0228.jpg",
    remarK: '../../../../../static/image/dsj/dsjimage1009.jpg',
    itemYear: "2020"
  },

  {
    id: "1010",
    itemName: "提升服务质量，优化服务效率，开通苏南、苏中、苏北冷链专线物流运营服务。",
    itemTime: "2020-03",
    itemImage: "../../../../../static/image/dsj/dsjimage1010.jpg",
    remarK: '',
    itemYear: "2020"
  },
  {
    id: "1011",
    itemName: "以满分成绩顺利通过国家卫健委新冠核酸检测质评。",
    itemTime: "2020-04-14",
    itemImage: "../../../../../static/image/dsj/dsjimage1011.jpg",
    remarK: '',
    itemYear: "2020"
  },
  {
    id: "1012",
    itemName: "联合南京医科大学附属逸夫医院，在疫情防控的关键时期，大力开展新冠核酸检测服务。",
    itemTime: "2020-04-20",
    itemImage: "../../../../../static/image/dsj/dsjimage1012.jpg",
    remarK: '',
    itemYear: "2020"
  },
  {
    id: "1013",
    itemName: "中标中国人民解放军东部战区总医院核酸检测服务项目，标志着华晟医学检验实验室的能力、服务等各方面能力得到了专业认可。",
    itemTime: "2020-06",
    itemImage: "../../../../../static/image/dsj/dsjimage1013.jpg",
    remarK: '',
    itemYear: "2020"
  },

  {
    id: "1014",
    itemName: "江河华晟医学“互联网体检小站”上线。",
    itemTime: "2020-08-18",
    itemImage: "../../../../../static/image/dsj/dsjimage1014.jpg",
    remarK: '',
    itemYear: "2020"
  },
  {
    id: "1015",
    itemName: "事业发展新起点，江河华晟总部暨江北新址实验室正式启用。",
    itemTime: "2020-10-18",
    itemImage: "../../../../../static/image/dsj/dsjimage1015.jpg",
    remarK: '',
    itemYear: "2020"
  },

  {
    id: "1017",
    itemName: "中标日领馆赴日签证新冠核酸检测服务项目，成为江苏省唯一指定服务商。",
    itemTime: "2020-10-20",
    itemImage: "",
    remarK: '',
    itemYear: "2020"
  },
  {
    id: "1016",
    itemName: "牵手湖南省长沙市岳麓高新区，湖南长沙实验室投资项目签约落地。",
    itemTime: "2020-10-21",
    itemImage: "../../../../../static/image/dsj/dsjimage1016.jpg",
    remarK: '',
    itemYear: "2020"
  },
  {
    id: "1018",
    itemName: "牵手河南省级经开区，河南郑州实验室投资项目签约落地。",
    itemTime: "2020-11-19",
    itemImage: "../../../../../static/image/dsj/dsjimage1119.jpg",
    remarK: '',
    itemYear: "2020"
  },
  {
    id: "1019",
    itemName: "南京卫健委专家领导一行验收江北实验室，一次性验收通过。",
    itemTime: "2020-11-23",
    itemImage: "../../../../../static/image/dsj/dsjimage1123.jpg",
    remarK: '',
    itemYear: "2020"
  },
  {
    id: "1020",
    itemName: "江北新区新址实验室HIV筛查实验室验收合格。",
    itemTime: "2021-01-05",
    itemImage: "../../../../../static/image/dsj/dsjimage1020.jpg",
    remarK: '',
    itemYear: "2021"
  },
  {
    id: "1021",
    itemName: "PCR及微生物实验室通过二级备案验收并获得证书。",
    itemTime: "2021-01-12",
    itemImage: "../../../../../static/image/dsj/dsjimage1021.jpg",
    remarK: '',
    itemYear: "2021"
  },
  {
    id: "1022",
    itemName: "南京江北新址实验室获批为南京市新冠核酸定点检测机构。",
    itemTime: "2021-01-29",
    itemImage: "../../../../../static/image/dsj/dsjimage1022.jpg",
    remarK: '',
    itemYear: "2021"
  },

  {
    id: "1023",
    itemName: "中标江苏省疾病预防控制中心环境样品核酸检测服务项目。",
    itemTime: "2021-02-02",
    itemImage: "../../../../../static/image/dsj/dsjimage1023.jpg",
    remarK: '',
    itemYear: "2021"
  },

  {
    id: "1024",
    itemName: "江河华晟医学与硕世生物签署战略合作协议。",
    itemTime: "2021-02-04",
    itemImage: "../../../../../static/image/dsj/dsjimage1024.JPG",
    remarK: '',
    itemYear: "2021"
  },

  {
    id: "1025",
    itemName: "完成南京高校返校师生核酸检测逾10万人次。",
    itemTime: "2021-03-31",
    itemImage: "../../../../../static/image/dsj/dsjimage1025.jpg",
    remarK: '',
    itemYear: "2021"
  },

  {
    id: "1026",
    itemName: "微E检3.0内测版上线。",
    itemTime: "2021-04-06",
    itemImage: "../../../../../static/image/dsj/dsjimage1026.jpg",
    remarK: '',
    itemYear: "2021"
  },

  {
    id: "1027",
    itemName: "长沙江河华晟医学检验实验室顺利通过竣工验收。",
    itemTime: "2021-05",
    itemImage: "../../../../../static/image/dsj/dsjimage1027.jpg",
    remarK: '',
    itemYear: "2021"
  },

  {
    id: "1028",
    itemName: "连续6个月获得由国家卫健委临床检验中心颁发的2021年度新冠核酸检测月度室间质评合格证书。",
    itemTime: "2021-06",
    itemImage: "../../../../../static/image/dsj/dsjimage0630.jpg",
    remarK: '',
    itemYear: "2021"
  },

  {
    id: "1029",
    itemName: "郑州江河华晟医学检验实验室开工建设。",
    itemTime: "2021-06-08",
    itemImage: "../../../../../static/image/dsj/dsjimage1029.jpg",
    remarK: '',
    itemYear: "2021"
  },

  {
    id: "1030",
    itemName: "长沙江河华晟医学检验实验室顺利通过长沙市卫健委验收。",
    itemTime: "2021-06-30",
    itemImage: "../../../../../static/image/dsj/dsjimage1030.jpg",
    remarK: '',
    itemYear: "2021"
  },

  {
    id: "1031",
    itemName: "微E检3.0试用版上线，医晟宝测试版上线。",
    itemTime: "2021-07",
    itemImage: "../../../../../static/image/dsj/dsjimage1031.png",
    remarK: '',
    itemYear: "2021"
  },

  {
    id: "1032",
    itemName: "完成“宁扬战疫”新冠核酸检测任务近300万人次。",
    itemTime: "2021-08",
    itemImage: "../../../../../static/image/dsj/dsjimage1032.jpg",
    remarK: '',
    itemYear: "2021"
  },

  {
    id: "1033",
    itemName: "中标南京医科大学附属口腔医院新冠核酸检测服务项目。",
    itemTime: "2021-09-04",
    itemImage: "../../../../../static/image/dsj/dsjimage1033.jpg",
    remarK: '',
    itemYear: "2021"
  },

  {
    id: "1034",
    itemName: "长沙江河华晟医学开业庆典成功举办，和湖南师范大学医学院签署战略合作协议。",
    itemTime: "2021-09-13",
    itemImage: "../../../../../static/image/dsj/dsjimage1034.JPG",
    remarK: '',
    itemYear: "2021"
  },

  {
    id: "1035",
    itemName: "郑州江河华晟医学顺利竣工验收。",
    itemTime: "2021-09-16",
    itemImage: "../../../../../static/image/dsj/dsjimage1035.jpg",
    remarK: '',
    itemYear: "2021"
  },

  {
    id: "1036",
    itemName: "江河华晟医学为南京市秋季高校返校师生提供大规模核酸检测服务。",
    itemTime: "2021-09-22",
    itemImage: "../../../../../static/image/dsj/dsjimage1036.jpg",
    remarK: '',
    itemYear: "2021"
  },
  {
    id: "1037",
    itemName: "2021年11月，顺利通过伯乐全球比对",
    itemTime: "2021-11",
    itemImage: "https://picture.hwason.cn/image/jpg/412766994021591872.jpg",
    remarK: '',
    itemYear: "2021"
  },
  {
    id: "1038",
    itemName: "2021年12月，完成数千万元A+轮融资。",
    itemTime: "2021-12",
    itemImage: "https://picture.hwason.cn/image/jpg/412767376177210752.jpg",
    remarK: '',
    itemYear: "2021"
  },
  {
    id: "1039",
    itemName: "2021年12月，江河华晟旗下的南京华晟医学检验实验室有限公司顺利通过高新技术企业认定，彰显了江河华晟在科技研发、技术创新等方面的实力。",
    itemTime: "2021-12",
    itemImage: "https://picture.hwason.cn/image/jpg/412767664107793920.jpg",
    remarK: '',
    itemYear: "2021"
  },


];


export {
  itemList
}



// WEBPACK FOOTER //
// ./src/components/website/aboutUs/component/data.js